import React, { useContext } from 'react';

import { Trans } from '@lingui/macro';

import PageContext from '@zego/context/PageContext';
import { disabledColor, white } from '@zego/theme';
import { useTracking } from '@zego/tracking';

import { getAppStoreLinkFromLanguage } from '@zego/components/AppStoreLink';
import Button from '@zego/components/button/ButtonLink';

const IconApple = ({ fill }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.034055,13.5102552 C20.0361513,15.4849916 21.2039744,17.2671187 23,18.0363611 C22.6545844,19.1726547 22.1339179,20.2464945 21.4572868,21.2181039 C20.5485976,22.5946083 19.5958445,23.9394035 18.0836519,23.9642606 C16.6143039,23.9986037 16.1204979,23.0886025 14.4351994,23.0886025 C12.7341122,23.0886025 12.2077841,23.9394137 10.7985325,23.9986037 C9.35840471,24.0526186 8.25779329,22.529451 7.3160638,21.1658586 C5.43381386,18.3811508 3.96814384,13.3181063 5.93308594,9.87306936 C6.85579306,8.19400503 8.5810245,7.12853663 10.4775683,7.06648804 C11.9189966,7.03645578 13.2575753,8.05227469 14.1438007,8.05227469 C15.0132012,8.05227469 16.6671968,6.83710493 18.373303,7.01845082 C19.9949513,7.06983012 21.4977364,7.89253759 22.4283177,9.2383896 C20.9598769,10.1525948 20.0562617,11.7648335 20.034055,13.5102552 L20.034055,13.5102552 Z M16.968071,5.47586996 C16.2482755,6.45099518 15.1576314,7.01266525 14.0089549,6.99978315 C13.935904,5.7771342 14.3120539,4.57300036 15.0545562,3.65259711 C15.8064922,2.71972548 16.8535083,2.12967022 17.9869862,2 C18.0754962,3.25889028 17.7099839,4.5057785 16.968071,5.47586996 L16.968071,5.47586996 Z"
      id="Apple-icon"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

const ItunesButton = ({ darkTheme = false, link, fullWidth = false }) => {
  const { trackEvent } = useTracking();
  const { language } = useContext(PageContext);

  const appStoreLink = link || getAppStoreLinkFromLanguage(language);

  return (
    <Button
      css={
        ({
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
        },
        [fullWidth ? { flex: '0 0 100%' } : null])
      }
      backgroundColor={darkTheme === true ? disabledColor(10) : white}
      icon={
        <IconApple fill={darkTheme === true ? white : disabledColor(10)} />
      }
      href={appStoreLink}
      onClick={event => {
        event.preventDefault();
        trackEvent('iTunes Button Click');
        if (typeof window !== 'undefined') {
          window.open(appStoreLink, '_blank');
        }
      }}
      title="Get the Zego app on the iOS App Store"
    >
      <Trans id="iTunes Button /  Get it for iOS">Get it for iOS</Trans>
    </Button>
  );
};

export default ItunesButton;
